import loadable from '@loadable/component';

export const PayByCreditCardContainerLoadable = loadable(
  () => import('./PayByCreditCardContainer'),
  { resolveComponent: (module) => module.PayByCreditCardContainer },
);
